export const CompanyActionTypes = {
  LOADING_REGISTER_COMPANY: 'LOADING_REGISTER_COMPANY',
  LOADING_COMPANY: 'LOADING_COMPANY',
  LOADING_SINGLE_COMPANY: 'LOADING_SINGLE_COMPANY',
  UPDATING_COMPANY: 'UPDATING_COMPANY',
  LOAD_COMPANY_START: 'LOAD_COMPANY_START',
  LOAD_COMPANY_SUCCESS: 'LOAD_COMPANY_SUCCESS',
  LOAD_COMPANY_FAILURE: 'LOAD_COMPANY_FAILURE',
  LOAD_LIST_COMPANY_START: 'LOAD_LIST_COMPANY_START',
  LOAD_LIST_COMPANY_SUCCESS: 'LOAD_LIST_COMPANY_SUCCESS',
  LOAD_LIST_COMPANY_FAILURE: 'LOAD_LIST_COMPANY_FAILURE',
  REGISTER_COMPANY_START: 'REGISTER_COMPANY_START',
  REGISTER_COMPANY_SUCCESS: 'REGISTER_COMPANY_SUCCESS',
  REGISTER_COMPANY_FAILURE: 'REGISTER_COMPANY_FAILURE',
  UPDATE_COMPANY_START: 'UPDATE_COMPANY_START',
  UPDATE_COMPANY_SUCCESS: 'UPDATE_COMPANY_SUCCESS',
  UPDATE_COMPANY_FAILURE: 'UPDATE_COMPANY_FAILURE',
  UPDATE_COMPANY_IN_LIST: 'UPDATE_COMPANY_IN_LIST',
};
